const MfaQueryKeys = {
  global: ["mfa"] as const,

  account: (accountId: string | undefined) =>
    [...MfaQueryKeys.global, "me", accountId] as const,
  settings: (accountId: string | undefined) =>
    [...MfaQueryKeys.account(accountId), "settings"] as const,
  setup: (accountId: string | undefined) =>
    [...MfaQueryKeys.account(accountId), "setup"] as const,
  codes: (accountId: string | undefined) =>
    [...MfaQueryKeys.account(accountId), "codes"] as const,
};

export { MfaQueryKeys };
